import React, { Component } from 'react';
import './App.css';
import ReactTooltip from 'react-tooltip'

import { Ajax } from './ajax/Ajax';

const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      reject(new Error("timeout"))
    }, ms)
    promise.then(resolve, reject)
  })
}

class App extends Component {
	
	constructor(props) {
		super();
		this.state = {dates: [], games: [], descriptions: [], posts: []};
	}
	
	getDescription() {
		var obj = this;
		return (game, idx) => {
			setTimeout(function () { Ajax.getUpcomingGame(game.url).then(function (info) {					
				var descriptions = obj.state.descriptions;
				descriptions[game.url] = info;
				obj.setState({descriptions: descriptions});
				return descriptions;
			}) }, 200);
		};
	}
	
	getGames() {
		var obj = this;
		return (date, idx) => {
			if (idx < 7)
			setTimeout(function () { Ajax.getUpcomingGamesFromUrl(date.url).then(function (dateGames) {					
				var games = obj.state.games;
				games[date.date.yyyymmdd()] = dateGames;
				obj.setState({games: games});
				dateGames.map(obj.getDescription());
				return dateGames;
		}) }, 200);
			
		};
	}
	
	componentWillMount() {
		var obj = this;
		
		Ajax.getUpcomingGames().then(function(dates) {
			obj.setState({dates: dates});
			dates.map(obj.getGames());
			return dates;
		}).then(function(whatever) {
			setTimeout(function () { return Ajax.getNewGames().then(function(games) {
				obj.setState({posts: games});
				return games;
			})}, 1000);
		});
	}
	
	render() {
		var dates = this.state.dates;
		var games = this.state.games;
		var descriptions = this.state.descriptions;
		var posts = this.state.posts;
		var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		var obj = this;
		return (
		<div className="App">
			<div className="MainTitle">Cette semaine chez les Saigneurs</div>
			<div className="Content">
				<div className="Calendar">
				  <div className="Title">Agenda</div>
					  { dates ? dates.map(function(date, idx) {			
							if (idx >= 7)
								return null;
							var output;
							var dateGames = games[date.date.yyyymmdd()];
							dateGames && descriptions ? output = (<div key={idx} className="Date"><div className="FormattedDate">{date.date.toLocaleDateString("fr-FR", options)}</div>
								{dateGames.map(function(game, gameIdx) {
										return (
											<div key={gameIdx} >
												<div 										
													className="Game" data-for={"game-" + idx + "-" + gameIdx} data-tip>
													<div className={"GameType" + game.type}>{game.type}</div>
													<div className="GameName">{game.title}</div>
												</div>
												<ReactTooltip id={"game-" + idx + "-" + gameIdx} html={true}>{descriptions[game.url]}</ReactTooltip>
											</div>);
								})}
							</div>): output = null;
							return output;
					  }) : null}
				</div>
		
				<div className="NewGames">
					<div className="Title">Nouvelles Parties</div>
					<div className="Board">
						{posts ? posts.map(function(post, postIdx) {
							if (! post.accueil) {
								return (<a key={postIdx} href={post.url} target="_blank"><div className="BoardGame"><div className="BoardGameName">{post.title}</div><div className="Author">{"MJ: " + post.user}</div></div></a>);
							}
							
						}) : null}
					</div>
				</div>
				<div className="AccueilGames">
					<div className="Title">Parties d'Accueil</div>
					<div className="Board">
					{posts ? posts.map(function(post, postIdx) {
							if (post.accueil) {
								return (<a key={postIdx} href={post.url} target="_blank"><div className="BoardGame"><div className="BoardGameName">{post.title}</div><div className="Author">{"MJ: " + post.user}</div></div></a>);
							}
							
						}) : null}
					</div>
				</div>
			</div>
		</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js